import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../components/SafeIcon';
import { FiBookmark, FiStar, FiNavigation, FiUsers } from 'react-icons/fi';
import { savedPlaces, recommenders } from '../data/mockData';

const Collections = () => {
  return (
    <div className="max-w-6xl mx-auto space-y-8 pb-20 md:pb-0">
      <header className="mb-8">
        <h1 className="text-2xl font-bold text-white mb-2 flex items-center">
          <SafeIcon icon={FiBookmark} className="mr-3 text-transit-neon" />
          MEMORY_BANKS
        </h1>
        <p className="text-gray-400 font-mono text-sm">Access saved coordinates and peer-to-peer recommendations.</p>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        
        {/* Saved Places */}
        <div className="lg:col-span-2 space-y-4">
          <h2 className="text-lg font-mono text-transit-neon border-b border-asphalt-700 pb-2">
            STORED_LOCATIONS
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {savedPlaces.map((place, idx) => (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                key={place.id}
                className="bg-asphalt-800 border-l-2 border-l-amber-500 border-y border-r border-asphalt-600 rounded-r-lg p-4 hover:bg-asphalt-700/50 transition-colors"
              >
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-base font-bold text-white">{place.name}</h3>
                  <span className="text-amber-500 flex items-center text-xs font-mono">
                    <SafeIcon icon={FiStar} className="mr-1 fill-current" /> {place.rating}
                  </span>
                </div>
                
                <div className="flex flex-wrap gap-2 text-xs font-mono mb-4 text-gray-400">
                  <span className="bg-asphalt-900 px-2 py-1 rounded">{place.category}</span>
                  <span className="bg-asphalt-900 px-2 py-1 rounded text-green-400">{place.cost}</span>
                  <span className="bg-asphalt-900 px-2 py-1 rounded flex items-center">
                    <SafeIcon icon={FiNavigation} className="mr-1" /> {place.distance}
                  </span>
                </div>

                <div className="flex space-x-2">
                   <button className="flex-1 py-1.5 bg-transit-500/10 text-transit-neon text-xs font-mono rounded border border-transit-500/30 hover:bg-transit-500 hover:text-white transition-colors">
                     SET_NAV
                   </button>
                   <button className="px-3 py-1.5 bg-asphalt-700 text-gray-400 text-xs font-mono rounded hover:text-white transition-colors">
                     DROP
                   </button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Friend Recommendations */}
        <div className="space-y-4">
          <h2 className="text-lg font-mono text-transit-neon flex items-center border-b border-asphalt-700 pb-2">
            <SafeIcon icon={FiUsers} className="mr-2" />
            P2P_NODES
          </h2>
          <div className="bg-asphalt-800 border border-asphalt-600 rounded-lg p-4 space-y-4">
            {recommenders.map((user, idx) => (
              <motion.div 
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 + (idx * 0.1) }}
                key={user.id} 
                className="flex items-center space-x-3 p-2 rounded hover:bg-asphalt-700 transition-colors"
              >
                <div className="relative">
                  <img src={user.avatar} alt={user.name} className="w-10 h-10 rounded border border-transit-500 object-cover filter grayscale hover:grayscale-0 transition-all" />
                  <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-asphalt-800" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-mono text-white">{user.name}</p>
                  <p className="text-xs text-gray-400 font-mono">Sync: <span className="text-transit-neon">{user.match}</span></p>
                </div>
                <button className="text-xs font-mono text-amber-500 hover:text-amber-400">
                  PING
                </button>
              </motion.div>
            ))}
            
            <div className="pt-4 border-t border-asphalt-700">
              <button className="w-full py-2 border border-dashed border-asphalt-500 text-gray-400 text-xs font-mono rounded hover:bg-asphalt-700 hover:text-white transition-colors">
                SCAN FOR NEW NODES
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Collections;